import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../../hooks/useUser'
import { SystemRoles, INTERNAL_ROLE_KEYS } from '../../providers/roles'

interface RouteRoleGuardProps {
  role?: keyof typeof SystemRoles
  roles?: Array<keyof typeof SystemRoles>
  children: JSX.Element
}

export function RouteRoleGuard({ role, roles, children }: RouteRoleGuardProps): JSX.Element {
  const { user, role: userRole, subscription: userSubscription } = useUser()
  const navigate = useNavigate()
  useEffect(() => {
    if (!user) {
      console.log("No user found, redirecting to login");
      navigate('/login')
    }

    if (roles && roles.length > 0) {
      if (!roles.includes(String(userRole) as keyof typeof SystemRoles)) {
        navigate('/403')
      }
      return
    }

    if (role === 'INTERNAL') {
      if(!INTERNAL_ROLE_KEYS.includes(String(userRole) as keyof typeof SystemRoles)) {
        navigate('/403');
      }
    } else if (role) {
      if (userRole !== role) {
        navigate('/403')
      }
    }


  }, [])

  return children
}
